<div class="row">
  <div class="col">
    <h2 [innerText]="'trRequestTemplates' | translate"></h2>
  </div>
</div>

<div class="row my-3">
  <div class="col-12">
    <input
      class="form-control"
      [(ngModel)]="searchText"
      [placeholder]="'trFilter' | translate"
    />
  </div>
</div>

<div class="row">
  <div class="col-12">
    <ds-table
      [items]="templates"
      [modelType]="ParticipantTemplate"
      (delete)="confirmDeleteNew($event)"
      [options]="options"
      [enableEditing]="false"
    >
    </ds-table>
  </div>
</div>
